/** Maintenance never stores API documents or queues writes on shared phones. */
export function isMaintenanceEndpoint(endpoint:string){
 try{
  const path=new URL(endpoint,"https://local.invalid").pathname.replace(/^\/api(?=\/)/,"");
  return path==="/maintenance"||path.startsWith("/maintenance/");
 }catch{return false}
}
